import { CircularProgress, Container } from '@mui/material';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import * as ProjectHelper from '../api/project/projectHelper';
import { EReduxState } from '../store/enum';
import { useAppDispatch, useAppSelector } from '../store/hook';
import { setMap } from '../store/map/mapSlice';
import { selectProject, setProject } from '../store/project/projectSlice';
import { selectResult } from '../store/result/resultSlice';
import { selectUser } from '../store/user/userSlice';
import Input from './Input';
import MultiScenario from './MultiScenario';
import NewEngine from './scenario/engine/NewEngine';

interface IDesignProps {}

const DesignContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
`;

var map: any;

const Design = (props: IDesignProps) => {
    let { projectId } = useParams();
    const [searchParams] = useSearchParams();

    let leaflet = (window as any).L;
    let leafletImage = (window as any).leafletImage;

    const divMap = React.useRef(null);

    const dispatch = useAppDispatch();
    const project = useAppSelector(selectProject);
    const result = useAppSelector(selectResult);
    const user = useAppSelector(selectUser);

    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchProject = async () => {
            setIsLoading(true);
            let project = await ProjectHelper.getProjectAsync(parseInt(projectId!), user.data!.email);
            setIsLoading(false);
            dispatch(setProject(project.data));
        };
        if (project.status == EReduxState.initialState) {
            fetchProject();
        }
    }, [project.status]);

    React.useEffect(() => {
        if (result.status == EReduxState.fulfilled) {
            var latitude = project.data?.project?.latitude!;
            var longitude = project.data?.project?.longitude!;
            if (map) map.remove();
            map = leaflet.map(divMap.current!).setView([latitude, longitude], 8);
            leaflet.marker([latitude, longitude]).addTo(map);
            leaflet
                .tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                })
                .addTo(map);
            //leafletImage works only map is in DOM, display none not work (line 79)
            leafletImage(map, (err: any, canvas: any) => {
                dispatch(setMap({ image: canvas.toDataURL() }));
            });
        }
    }, [result]);
    
    return (
        <DesignContainer maxWidth={false}>
            {result.status == EReduxState.fulfilled && (
                <>
                    <Stack ref={divMap} style={{ width: 300, height: 300, position: 'absolute', visibility: 'hidden' }} />
                    {project.data?.scenarios?.map((x, i) => (
                        <Stack style={{ width: 434, height: 398, position: 'absolute', visibility: 'hidden' }}>
                            <NewEngine index={i} export />
                        </Stack>
                    ))}
                </>
            )}
            <Stack height={'100%'} direction={'row'} spacing={0.5}>
                {isLoading && <CircularProgress />}
                {!isLoading && project.status == EReduxState.fulfilled && (
                    <>
                        <Stack sx={{ width: { xs: '30%', md: '24%' } }} position='relative'>
                            <Input />
                        </Stack>
                        <Stack sx={{ width: { xs: '70%', md: '76%' } }}>
                            <MultiScenario withInitialCalculation={!!searchParams.get('withCalculation')} />
                        </Stack>
                    </>
                )}
            </Stack>
        </DesignContainer>
    );
};

export default Design;
